import { HttpResponse } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { FileDownloadService } from '@services/file-download.service';
import { FilenameParser } from '@utils/FilenameParser';
import { take } from 'rxjs/operators';
import { HistoricoComprasUsuarioService } from 'src/app/services/historico-compras-usuario.service';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { DateMaskDirective } from '../../directives/date-mask.directive';
import { FormsModule } from '@angular/forms';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatSuffix } from '@angular/material/form-field';
import { NgClass } from '@angular/common';
import { SelectComponent } from '../../components/select/select.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { AppDatePipe } from '../../pipes/app-date.pipe';

@Component({
    selector: 'app-historico-compras-usuario',
    templateUrl: './historico-compras-usuario.component.html',
    styleUrls: ['./historico-compras-usuario.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, BreadcrumbComponent, DateMaskDirective, FormsModule, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, NgClass, SelectComponent, FooterComponent, AppDatePipe]
})
export class HistoricoComprasUsuarioComponent implements OnInit {
  historicoCompras: any = null;
  idUsuario = 0;
  dataInicial: any = '';
  dataFinal: any = '';
  pagina: any = 0;
  tamanho: any = 6;
  itensPaginacao: Array<any> = [];
  dataFiltrada = false;
  dataFinalMenor = false;
  dataformatada: boolean;
  dataInicialFormatada: string;
  dataFinalFormatada: string;
  edicaoUsuario: boolean;

  constructor(private readonly rotaAtiva: ActivatedRoute,
              private readonly service: HistoricoComprasUsuarioService,
              public rota: Router) { }

  ngOnInit(): void {
    this.rotaAtiva.queryParams.subscribe((data: any) => {
      this.idUsuario = data.idUsuario;
      this.edicaoUsuario = data.edicaoUsuario;
      this.consultaHistoricoCompras();
    });
  }

  consultaHistoricoCompras() {
    this.historicoCompras = null;

    this.service.getAllHistoricoCompras(this.idUsuario, this.dataInicialFormatada, this.dataFinalFormatada, this.pagina, this.tamanho)
    .pipe(take(1))
    .subscribe({
        next: (response: any) => {
            if (response.status === 'OK' && response.response !== null) {
                this.historicoCompras = response.response;
                this.configsPaginacao();
                if (this.dataformatada === true) {
                    this.dataInicial = new Date(this.dataInicial);
                    this.dataFinal = new Date(this.dataFinal);
                    this.dataformatada = false;
                }
            } else {
                this.historicoCompras = undefined;
            }
        },
        error: (erro: any) => {
            console.error(erro);
            this.historicoCompras = false;
        }
    });
  }

  filtrar() {
    const dataFinal = this.dataFinal;
    const dataInicial = this.dataInicial;

if (dataFinal >= dataInicial) {
    this.pagina = 0;
    this.dataFiltrada = true;
    this.dataFinalMenor = false;
    if (!this.dataformatada && String(this.dataFinal).length > 10 && String(this.dataInicial).length > 10) {
        this.dataFinalFormatada = this.dataFinal.toLocaleDateString('pt-BR');
        this.dataInicialFormatada = this.dataInicial.toLocaleDateString('pt-BR');
        this.dataformatada = true;
    } 
    this.consultaHistoricoCompras();
    } else {
      this.dataFinalMenor = true;
    }
  }

  limparFiltro() {
    this.pagina = 0;
    this.dataFiltrada = false;
    this.dataInicialFormatada = '';
    this.dataFinalFormatada = '';
    this.dataFinal = '';
    this.dataInicial = '';
    this.dataFinalMenor = false;
    this.consultaHistoricoCompras();
  }

  // FUNÇÕES DA PAGINAÇÃO
  alteraPagina(numeroPagina: any) {

    if (this.pagina !== numeroPagina && numeroPagina !== '...'){
      this.pagina = numeroPagina;
      this.consultaHistoricoCompras();
    }
  }

  alteraQuantidadePorPagina() {
    this.pagina = 0;
    this.consultaHistoricoCompras();
  }

  configsPaginacao() {

    this.itensPaginacao = [];

    if (this.historicoCompras.pageRequest.totalPages <= 7) {

      for (let i = 0; i < this.historicoCompras.pageRequest.totalPages; i++) {
        const objPagina = {
          valor: i,
          pagina: i + 1
        };
        this.itensPaginacao.push(objPagina);
      }
    } else if (this.pagina >= 0 && this.pagina <= 3) {

        this.itensPaginacao = [
          {
            valor: 0,
            pagina: 1
          },
          {
            valor: 1,
            pagina: 2
          },
          {
            valor: 2,
            pagina: 3
          },
          {
            valor: 3,
            pagina: 4
          },
          {
            valor: 4,
            pagina: 5
          },
          {
            valor: '...',
            pagina: '...'
          },
          {
            valor: this.historicoCompras.pageRequest.totalPages - 1,
            pagina: this.historicoCompras.pageRequest.totalPages
          }
        ];

      } else if (this.pagina === this.historicoCompras.pageRequest.totalPages ||
        this.pagina === this.historicoCompras.pageRequest.totalPages - 1 ||
        this.pagina === this.historicoCompras.pageRequest.totalPages - 2 ||
        this.pagina === this.historicoCompras.pageRequest.totalPages - 3 ) {

        this.itensPaginacao = [
          {
            valor: 0,
            pagina: 1
          },
          {
            valor: '...',
            pagina: '...'
          },
          {
            valor: this.historicoCompras.pageRequest.totalPages - 5,
            pagina: this.historicoCompras.pageRequest.totalPages - 4
          },
          {
            valor: this.historicoCompras.pageRequest.totalPages - 4,
            pagina: this.historicoCompras.pageRequest.totalPages - 3
          },
          {
            valor: this.historicoCompras.pageRequest.totalPages - 3,
            pagina: this.historicoCompras.pageRequest.totalPages - 2
          },
          {
            valor: this.historicoCompras.pageRequest.totalPages - 2,
            pagina: this.historicoCompras.pageRequest.totalPages - 1
          },
          {
            valor: this.historicoCompras.pageRequest.totalPages - 1,
            pagina: this.historicoCompras.pageRequest.totalPages
          }
        ];

      } else {
        this.itensPaginacao = [
          {
            valor: 0,
            pagina: 1
          },
          {
            valor: '...',
            pagina: '...'
          },
          {
            valor: this.pagina - 1,
            pagina: this.pagina
          },
          {
            valor: this.pagina,
            pagina: this.pagina + 1
          },
          {
            valor: this.pagina + 1,
            pagina: this.pagina + 2
          },
          {
            valor: '...',
            pagina: '...'
          },
          {
            valor: this.historicoCompras.pageRequest.totalPages - 1,
            pagina: this.historicoCompras.pageRequest.totalPages
          }
        ];
      }
  }

  exportarRelatorio( ) {

    this.service.exportarRelatorio(this.idUsuario, this.dataInicialFormatada, this.dataFinalFormatada)
    .subscribe({
        next: ({ body, headers }: HttpResponse<any>) => {
            const filename = FilenameParser.fromContentDispositionHeader(
                headers.get('content-disposition'),
                'Arquivo.pdf',
            );
            FileDownloadService.download([body], filename);
        },
        error: (erro: any) => {}
    });
  }

  goBackPage() {
    this.rota.navigate(['/dados-usuario/', this.idUsuario]);

  }
}
